import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';

class OffersV4Task extends AbstractRequestTask {
    constructor(url = null) {
        super();
        this.url = url;
    }

    getUrl() {
        const http = "http://";
        const akamai = Launcher.get("akamai_mfwk");
        const path = this.url || '/services/plans/v4/offers';
        return `${http}${akamai}${path}`;
    }

    getHeaders() {
        const params = super.getParams();
        if (params.user_token) {
            return {
                'Authorization': 'Bearer ' + params.user_token
            };
        }
        return {};
    }

    getParams() {
        const params = super.getParams();
        delete params.user_token;
        delete params.api_version;
        delete params.HKS;
        delete params.device_name;
        delete params.device_so;
        delete params.format;
        return params;
    }

    isValid(data) {
        const hasDataRoot = data && data.data && Array.isArray(data.data);
        const hasOffersRoot = data && data.offers && Array.isArray(data.offers);

        if (!hasDataRoot && !hasOffersRoot) {
            return false;
        }

        return true;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default OffersV4Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/OffersV4Task.js